/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de devoluciones.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
*      2       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Ajuste de distribucion visual portatil por estilos scoped
*      3       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Modales independientes y responsivos para devoluciones
* ---------------------------------------------------------------------------------------
*/

import FrmDevoluciones from "../../ventas/FrmDevoluciones.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";
import ModalBuscarRemisionesDevolucionesPortatil, {
  modalBuscarRemisionesPortatilStyle,
} from "../modales/ModalBuscarRemisionesDevolucionesPortatil.jsx";
import ModalReimpresionRemisionesPortatil from "../modales/ModalReimpresionRemisionesPortatil.jsx";

export default function FrmDevolucionesPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmDevoluciones">
      <FrmDevoluciones
        ModalBuscarRemisionesRoot={ModalBuscarRemisionesDevolucionesPortatil}
        modalBuscarRemisionesStyleOverride={modalBuscarRemisionesPortatilStyle}
        ModalReimpresionRemisionesComponent={ModalReimpresionRemisionesPortatil}
      />
    </SizeSoftXFrmPortatil>
  );
}
